import React from "react";
import { defineMessages, injectIntl } from "react-intl";
import PropTypes from "prop-types";

const messages = defineMessages({
    inProgress: {
        id: "Käsittelyssä",
        defaultMessage: "Käsittelyssä"
    },
    actionNeeded: {
        id: "Odottaa vastaustasi",
        defaultMessage: "Odottaa vastaustasi"
    },
    resolved: {
        id: "Ratkaistu",
        defaultMessage: "Ratkaistu"
    },
    messageStatus: {
        id: "Viestin tila",
        defaultMessage: "Viestin tila"
    }
});

export { messages };

const MessageStatus = (props) => {
    const lng = props.intl.formatMessage;

    const resolveTypeAndStatus = () => {
        let badgeType;
        let statusText;
        if (props.originalStatus !== undefined && props.originalStatus !== null) {
            switch (props.originalStatus) {
                // Resolved
                case 'Canceled':
                case 'Closed':
                case 'Resolved':
                    statusText = lng(messages.resolved);
                    badgeType = 'bg-success';
                    break;
                // Action Needed
                case 'Waiting for customer':
                    statusText = lng(messages.actionNeeded);
                    badgeType = 'bg-danger';
                    break;
                // In Progress
                case 'Waiting for support':
                case 'Waiting for 3rd party':
                case 'In Progress':
                case 'Pending':
                case 'Escalate':
                case 'Escalated':
                default:
                    statusText = lng(messages.inProgress);
                    badgeType = 'bg-primary';
                    break;
            }
        } else {
            statusText = lng(messages.inProgress);
            badgeType = 'bg-primary';
        }
        return { badgeType, statusText };
    }

    const { badgeType, statusText } = resolveTypeAndStatus();

    return (
        <div className={'badge ' + badgeType} aria-label={lng(messages.messageStatus) + ' ' + statusText}>
            {statusText}
        </div>
    );
};

MessageStatus.propTypes = {
    originalStatus: PropTypes.string,
    intl: PropTypes.object.isRequired
};

export default injectIntl(MessageStatus);
